module.exports = __webpack_public_path__ + "static/img/10.78f5aca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/eng/10.png
// module id = LGie
// module chunks = 0